import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 10.667h32v10.667H0z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E87E04",
      fillRule: "evenodd",
      d: "m16 18.917-.73 1.692-.171-1.835-1.217 1.384.404-1.798-1.586.94.94-1.586-1.798.405 1.384-1.218-1.835-.171 1.693-.73-1.693-.73 1.835-.171-1.384-1.218 1.798.405-.94-1.586 1.586.94-.404-1.798 1.217 1.384.171-1.835.73 1.692.73-1.692.171 1.835 1.218-1.384-.404 1.798 1.585-.94-.94 1.586 1.798-.405-1.384 1.218 1.835.171-1.692.73 1.692.73-1.835.171 1.384 1.218-1.798-.405.94 1.586-1.585-.94.404 1.798-1.218-1.384-.17 1.835z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M16 18.667a2.667 2.667 0 1 1 0-5.334 2.667 2.667 0 0 1 0 5.334",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagArg = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagArg_default = SvgFlagArg;

export { FlagArg_default as default };
